



















import { apiService } from "@/core/ApiService";
import store from "@/store";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class AppResidentCommentDialog extends Vue {
  @Prop() ïsWeaponCarryingDialogVisible: boolean;
  @Prop() personId: string;
  @Prop() onNavigateResidentByStatusCode: Function;
  @Prop() lessThenYearMsg: Array<any>;
  requestTypeAnswer: boolean = false;
  ishurFile: any = null;
  constructor() {
    super();
  }

  // if (this.responseMsgs != null) {
  //     let lessThenOneYearMsg = this.responseMsgs.filter(q => q["msgCode"] == "lessThenYear");
  //     if (lessThenOneYearMsg.length == 1) {
  //       this.appEnv.showErrorDialog(lessThenOneYearMsg, true);
  //       return;
  //     }
  //   }

  created() { }

  onChooseRequest(): void {
    if (this.requestTypeAnswer) {
      this.GetWeaponCarryingDoc();
    } else {
      this.onNavigateResidentByStatusCode();
      this.ïsWeaponCarryingDialogVisibleLocal = false;
    }
  }

  GetWeaponCarryingDoc() {
    if (this.personId == null || this.personId == 'undefined' || this.personId == "") return;
    this.appEnv.isBusy = true;
    apiService
      .getFile(
        "Approvment/GetAuthorizedWeaponCarryingDoc",
        this.personId
      )
      .then((res) => {
        if (res) {
          if (res.size > 0) {
            this.ishurFile = res;
            this.fileDownload();
          } else {
            this.onShowFileError();
          }
        } else {
          this.onShowFileError();
        }
        this.appEnv.isBusy = false;
        this.ïsWeaponCarryingDialogVisibleLocal = false;
      })
      .catch((err) => {
        this.onShowFileError();
        this.appEnv.isBusy = false;
      });
  }

  fileDownload() {
    const url = window.URL.createObjectURL(new Blob([this.ishurFile]));
    const link = document.createElement("a");
    link.href = url;
    var fileName = "אישור לנשק" + ".pdf";
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  }

  onShowFileError() {
    this.appEnv.showErrorDialog([
      { message: "לא ניתן להציג אישור עבור תושב" },
    ]);
  }

  get ïsWeaponCarryingDialogVisibleLocal() {
    return this.ïsWeaponCarryingDialogVisible;
  }

  set ïsWeaponCarryingDialogVisibleLocal(value) {
    this.$emit("update:ïsWeaponCarryingDialogVisible", value);
  }

  get appEnv() {
    return store.getters.appEnv;
  }


  onGetRequestTypesOptions() {
    let arr = [];
    if (this.lessThenYearMsg.length > 0) {
      this.requestTypeAnswer = true;
      arr = [{ label: "אישור נשק", value: true }];
    } else {
      arr = [{ label: "אישור תושב", value: false }, { label: "אישור נשק", value: true }];
    }
    return arr;
  }
}
